import { useTranslation } from "react-i18next";

import { Text } from "@/components/ui/Text";

import type { PublicStoryline } from "@digital-twins/shared-types/reporting";

interface StorylineContextLineProps {
  brandContext: PublicStoryline["brandContext"];
}

/** Whose story this is: the brand it is read for, and the competitors named. */
export function StorylineContextLine(props: StorylineContextLineProps) {
  const { brandContext } = props;

  const { t } = useTranslation("app");

  const brand = brandContext?.brandName?.trim();
  if (!brand) {
    return null;
  }
  const competitors = (brandContext?.competitorNames ?? [])
    .map((name) => name.trim())
    .filter(Boolean);

  return (
    <Text
      size="sm"
      color="muted"
      className="leading-snug"
      data-testid="storyline-context"
    >
      {competitors.length > 0
        ? t("studyReport.storyline.contextBrandCompetitors", {
            brand,
            competitors: competitors.join(", "),
          })
        : t("studyReport.storyline.contextBrand", { brand })}
    </Text>
  );
}
